import type { FunctionComponent, PropsWithChildren } from 'react';
import PersonaDialog from './PersonaDialog';
import { NARRATOR } from '../../data/Personas';

export interface Props {
	text: string[];
	onClose?: () => void;
}

const NarratorDialog: FunctionComponent<Props> = (
	props: PropsWithChildren<Props>
) => {
	const { children, text, onClose } = props;

	return (
		<PersonaDialog
			onClose={onClose}
			persona={NARRATOR}
			text={text}
			highlightClose={false}
		>
			{children}
		</PersonaDialog>
	);
};

export default NarratorDialog;
